const API_URL = {
    local: 'https://localhost:44384/',
    qa: 'https://webfulleretteqa.fuller.com.mx/',
    produccion: 'https://webfullerette.fuller.com.mx/'
}

const Setting = {
    API_URL: API_URL.produccion
}

module.exports = { Setting };